import {
	authInterceptorFactory,
	axios,
	interceptAndNormalizeResponse,
	piggyBack,
	requestHeaderNormalizerInterceptor
} from "@teaming/io-helpers";

const IO_INBOX_NAMESPACE = "inbox";

export default function ioInboxFactory( { config: { baseUri }, authService, } ) {
	axios.defaults.baseURL = baseUri;
	axios.interceptors.request.use( requestHeaderNormalizerInterceptor );
	axios.interceptors.request.use( authInterceptorFactory( { authService, } ) );
	axios.interceptors.response.use( ...interceptAndNormalizeResponse() );

	return {
		namespace: IO_INBOX_NAMESPACE,
		fetchTeamlessMeetings: piggyBack( async (participants = false) => {
			// eslint-disable-next-line
			const url = `/teamless-meeting${participants ? '?participants=1' : ''}`;
			const result = await axios({
				method: 'get',
				url: url
			});
			return result.data || [];
		}),
		fetchTeamChoices: piggyBack( async () => {
			const response = await axios({
				method: 'get',
				url: '/team'
			});
			const { data: allTeams, } = response;
			// eslint-disable-next-line
			return allTeams || [];
		}),
		/**
		 *
		 * @param {string} meetingId
		 * @param {Object} data
		 * @returns {Promise<number>}
		 */
		updateTeamlessMeeting: async ( meetingId, data ) => {
			const result = await axios({
				method: 'put',
				url: `/teamless-meeting/${meetingId}`,
				data
			});
			return result.status;
		}
	};

}
